import React from 'react';
import { BarChart2, Target, TrendingUp, DollarSign } from 'lucide-react';
import { formatCurrency, formatNumber, formatPercent } from '../../../../../utils/formatting';

/**
 * Компонент обзора результатов рекламной кампании
 */
const ResultsOverview = ({ results }) => {
  // Если результаты не получены, возвращаем null
  if (!results) return null;

  // Извлекаем ключевые показатели из результатов
  const { 
    campaign, 
    performance, 
    audience, 
    effectiveness 
  } = results;

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm p-5 mt-8">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-medium text-gray-900 dark:text-white flex items-center">
          <BarChart2 className="w-5 h-5 mr-2 text-indigo-500" />
          Результаты кампании
        </h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Общий бюджет */}
        <div className="bg-gray-50 dark:bg-gray-700/30 rounded-lg p-4 border border-gray-200 dark:border-gray-700">
          <div className="flex items-center justify-between mb-2">
            <DollarSign className="w-5 h-5 text-green-500" />
            <span className="text-sm font-medium text-gray-500 dark:text-gray-400">Бюджет</span>
          </div>
          <div className="text-lg font-bold text-gray-900 dark:text-white">
            {formatCurrency(campaign.totalBudget, 0)}
          </div>
          <p className="text-xs text-gray-500 dark:text-gray-400">
            {formatCurrency(campaign.costPerDay, 0)} в день
          </p>
        </div>

        {/* Охват аудитории */}
        <div className="bg-gray-50 dark:bg-gray-700/30 rounded-lg p-4 border border-gray-200 dark:border-gray-700">
          <div className="flex items-center justify-between mb-2">
            <Target className="w-5 h-5 text-blue-500" />
            <span className="text-sm font-medium text-gray-500 dark:text-gray-400">Охват</span>
          </div>
          <div className="text-lg font-bold text-gray-900 dark:text-white">
            {formatNumber(audience.estimatedReach, 0)}
          </div>
          <p className="text-xs text-gray-500 dark:text-gray-400">
            {formatPercent(audience.reachPercent, 1)} от целевой аудитории
          </p>
        </div>

        {/* Конверсии */}
        <div className="bg-gray-50 dark:bg-gray-700/30 rounded-lg p-4 border border-gray-200 dark:border-gray-700">
          <div className="flex items-center justify-between mb-2">
            <TrendingUp className="w-5 h-5 text-purple-500" />
            <span className="text-sm font-medium text-gray-500 dark:text-gray-400">Конверсии</span>
          </div>
          <div className="text-lg font-bold text-gray-900 dark:text-white">
            {formatNumber(performance.totalConversions, 0)}
          </div>
          <p className="text-xs text-gray-500 dark:text-gray-400">
            {formatPercent(performance.averageConversionRate, 1)} средний %
          </p>
        </div>

        {/* Эффективность */}
        <div className="bg-gray-50 dark:bg-gray-700/30 rounded-lg p-4 border border-gray-200 dark:border-gray-700">
          <div className="flex items-center justify-between mb-2">
            <BarChart2 className="w-5 h-5 text-indigo-500" />
            <span className="text-sm font-medium text-gray-500 dark:text-gray-400">Эффективность</span>
          </div>
          <div className="text-lg font-bold text-gray-900 dark:text-white">
            {effectiveness.score}/100
          </div>
          <p className="text-xs text-gray-500 dark:text-gray-400">
            ROI: {formatPercent(performance.totalROI, 1)}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ResultsOverview;